interface IconProps {
  fillColor: string
}

export const SwitchToMobileIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M83.5462 43.8C84.2826 43.8 84.8796 43.203 84.8796 42.4666C84.8796 41.7303 84.2826 41.1333 83.5462 41.1333C82.8098 41.1333 82.2129 41.7303 82.2129 42.4666C82.2129 43.203 82.8098 43.8 83.5462 43.8Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.6667 34.8667C31.8316 34.8667 29.5334 37.165 29.5334 40V73.5334H27.1667C25.8964 73.5334 24.8667 74.5631 24.8667 75.8334C24.8667 78.3923 26.9411 80.4667 29.5 80.4667H90.5C93.059 80.4667 95.1334 78.3923 95.1334 75.8334C95.1334 74.5631 94.1036 73.5334 92.8334 73.5334H90.4667V40C90.4667 37.165 88.1684 34.8667 85.3334 34.8667H34.6667ZM53.551 75.8C53.5394 75.865 53.5334 75.9318 53.5334 76C53.5334 76.626 54.0408 77.1334 54.6667 77.1334H65.3334C65.9593 77.1334 66.4667 76.626 66.4667 76C66.4667 75.9318 66.4607 75.865 66.4491 75.8H92.8334C92.8401 75.8 92.846 75.8022 92.846 75.8022C92.8492 75.8035 92.8531 75.806 92.8569 75.8098L92.8602 75.8135L92.8637 75.8189L92.8645 75.8207C92.8645 75.8207 92.8667 75.8267 92.8667 75.8334C92.8667 77.1404 91.8071 78.2 90.5 78.2H29.5C28.193 78.2 27.1334 77.1404 27.1334 75.8334C27.1334 75.8267 27.1355 75.8207 27.1355 75.8207C27.1369 75.8176 27.1393 75.8136 27.1431 75.8098C27.147 75.806 27.1509 75.8035 27.1541 75.8022C27.1541 75.8022 27.16 75.8 27.1667 75.8H53.551ZM31.8 40C31.8 38.4168 33.0835 37.1334 34.6667 37.1334H85.3334C86.9166 37.1334 88.2 38.4168 88.2 40V73.5334H31.8V40Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
